import { useEffect } from 'react';
import SidePage from '@gogame/ui/SidePage';

import { Sentry } from '../Sentry';

const OriginalContent = SidePage.Content;
const OriginalTabs = SidePage.Tabs;
const OriginalSidebar = SidePage.Sidebar;
const OriginalNewContent = SidePage.NewContent;
const OriginalNewBody = SidePage.NewBody;
const OriginalBody = SidePage.Body;
const OriginalTitle = SidePage.Title;

const SidePageTitleBreadcrumbs = ({ children, title, subTitle, entityId }) => {

  useEffect(() => {
    if (title && entityId && subTitle) {
      Sentry.addBreadcrumb('ui.interaction', `SidePage "${title}"`, {
        title,
        subTitle,
        entityId,
      });
    }
    if (title && !entityId) {
      Sentry.addBreadcrumb({
        category: 'ui.interaction',
        message: `SidePage "${title}"`,
        type: 'user.action'
      });
    }
  }, [title, subTitle, entityId]);

  return children;
};

SidePage.Title = ({ children, ...props }) => {
  return (
    <Sentry.SidePageErrorBoundary>
      <SidePageTitleBreadcrumbs {...props}>
        <OriginalTitle {...props}>{children}</OriginalTitle>
      </SidePageTitleBreadcrumbs>
    </Sentry.SidePageErrorBoundary>
  );
};
SidePage.Body = ({ children, ...props }) => {
  return (
    <Sentry.SidePageErrorBoundary>
      <OriginalBody {...props}>{children}</OriginalBody>
    </Sentry.SidePageErrorBoundary>
  );
};
SidePage.Tabs = ({ children, ...props }) => {
  return (
    <Sentry.SidePageErrorBoundary>
      <OriginalTabs {...props}>{children}</OriginalTabs>
    </Sentry.SidePageErrorBoundary>
  );
};
SidePage.Sidebar = ({ children, ...props }) => {
  return (
    <Sentry.SidePageErrorBoundary>
      <OriginalSidebar {...props}>{children}</OriginalSidebar>
    </Sentry.SidePageErrorBoundary>
  );
};
SidePage.NewContent = ({ children, ...props }) => {
  return (
    <Sentry.SidePageErrorBoundary>
      <OriginalNewContent {...props}>{children}</OriginalNewContent>
    </Sentry.SidePageErrorBoundary>
  );
};
SidePage.Content = ({ children, ...props }) => {
  return (
    <Sentry.SidePageErrorBoundary>
      <OriginalContent {...props}>{children}</OriginalContent>
    </Sentry.SidePageErrorBoundary>
  );
};
SidePage.NewBody = ({ children, ...props }) => {
  return (
    <Sentry.SidePageErrorBoundary>
      <OriginalNewBody {...props} padding>
        {children}
      </OriginalNewBody>
    </Sentry.SidePageErrorBoundary>
  );
};
export default SidePage;
